import { useMutation } from "@apollo/client";
import { UseDownloadStockCountResponse } from "./types";
import { DownloadStockCountCsvBase64StringResponse } from "@towersystems/roam-common/lib/generated-types";
import { useDownloadBase64String } from "../base-64/use-download-base-64-string";
import { MUTATION_DOWNLOAD_STOCK_COUNT } from "./constants";
import { useCallback } from "react";

export const useDownloadStockCount = (): UseDownloadStockCountResponse => {
  const { downloadBase64String } = useDownloadBase64String();

  const [q, { loading }] = useMutation<{
    downloadStockCountCsvBase64String: DownloadStockCountCsvBase64StringResponse;
  }>(MUTATION_DOWNLOAD_STOCK_COUNT);

  const fn = useCallback(
    async (stockCountId: string) => {
      return q({ variables: { stockCountId } }).then((i) => {
        const { data: base64String, fileName } =
          i.data?.downloadStockCountCsvBase64String || {};

        downloadBase64String({
          base64String,
          fileName,
          blobType: "text/csv",
        });
      });
    },
    [q]
  );
  return {
    downloadStockCount: fn,
    loading,
  };
};
